<!--
  @description: 司机确认收款详情
  @filePath:src\modules\transport\bms\views\finance\billDetails\components\DriverCollectionDetails.vue
-->
<template>
    <div class="driverCollectionDetails">
        <m-pane
            ref="driverCollectionDetailsTable"
            class="driverCollectionDetailsTable"
            pageID="driverCollectionDetails"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :currentPage="currentPage"
            @pageChange="handlePageChange"
            @sizeChange="handleSizeChange"
            >
        </m-pane>
    </div>
</template>
<script>
import mPane from '@/modules/transport/bms/components/Table/Index.vue';
import mTableMixin from '@/modules/transport/bms/mixins/mTableMixin.js';
import { getPageEiOtpEtdoFrozen } from '@/modules/transport/bms/api/billDetails.js';

export default {
    name: 'DriverCollectionDetails',
    components: { mPane },
    mixins: [mTableMixin],
    props: {
        apBillNo: {
            type: [String, Number]
        }
    },
    watch: {
        apBillNo: {
            immediate: true,
            handler: function () {
                this.queryList();
            }
        }
    },
    data() {
        return {
            btnLoading: false,
            config: {
                configuration: true,
                'table': {
                    'switchType': true,
                    'tableCut': false,
                    'clickState': false,
                    'isPagination': true,
                    'height': 'auto',
                    'columns': [
                        {
                            'label': '发车单号',
                            'prop': 'etdoNo',
                            'width': '50px'
                        },
                        {
                            'label': '司机编码',
                            'prop': 'driverCode',
                            'width': '50px'
                        },
                        {
                            'label': '司机名称',
                            'prop': 'driverName',
                            'width': '50px'
                        },
                        {
                            'label': '司机运费确认状态',
                            'prop': 'frozenState',
                            'type': 'select',
                            'optionNum': 'BMS_DRIVER_CONFIRMS_PAY_STATUS',
                            'width': '40px'
                        },
                        {
                            'label': '司机确认时间',
                            'prop': 'releaseTime',
                            'width': '40px'
                        },
                        {
                            'label': '确认人',
                            'prop': 'releaser',
                            'type': 'select',
                            'optionNum': 'BMS_OTP_ETDO_FROZEN_RELEASER',
                            'width': '40px'
                        }
                    ]
                },
                'page': {
                    'layout': 'total, sizes, prev, pager, next, jumper',
                    'pageSize': 10
                }
            }
        };
    },
    methods: {
        /** 查询 **/
        queryListExecute({ params, successCallback }) {
            if (!this.apBillNo) return;
            params = { 'apBillNo': this.apBillNo };
            getPageEiOtpEtdoFrozen(params).then(async (res) => {
                if (res && +res.code === 0) {
                    this.$emit('resData', res);
                    successCallback(res);
                }
            });
        }
    },
    created() {
    }
};
</script>
<style lang="less" scoped>
.driverCollectionDetails{
}
</style>
